import smoothscroll from 'smoothscroll-polyfill';
// Add smooth scroll
smoothscroll.polyfill();
export default class R14DomUtilsBase {
  getPropertyUnitValues(target, property, unit) {
    let baseline = 100;  // any number serves 
    let item;  // generic iterator

    let map = this.getPropertyUnitMap();

    let factors = {};
    let units = {};

    let value = target[property] || this.getComputedStyle(target, property);

    let numeric = this.stripPropertyValueUnit(value);
    if (numeric === null) throw ("getPropertyUnitValues: Invalid property value returned");
    let computedUnit = this.getPropertyUnitByValue(value);

    let currUnit;
    for (item in map) {
      if (map[item] == computedUnit) {
        currUnit = item;
        break;
      }
    }
    if (!currUnit) throw ("getPropertyUnitValues: Computed unit not found");

    if (unit) {
      // Convert unit to a map idx
      unit = this.getPropertyUnitMapIdx(unit, map);
      let tMap = {};
      tMap[currUnit] = map[currUnit];
      tMap[unit] = map[unit];
      map = tMap;
    }

    let temp = document.createElement("div");
    temp.style.overflow = "hidden";
    temp.style.visibility = "hidden";
    target.parentElement.appendChild(temp);
    for (item in map) {
      temp.style.width = baseline + map[item];
      factors[item] = baseline / temp.offsetWidth;
    }
    for (item in map) {
      units[item] = numeric * (factors[item] * factors[currUnit]);
    }
    target.parentElement.removeChild(temp);

    return units;
  }
  offset(elmt) {
    let rect = elmt.getBoundingClientRect();
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }
  dimensions(elmt) {
    let rect = elmt.getBoundingClientRect();
    return { height: rect.height, width: rect.width }
  }
  scrollPosition() {
    return {
      top: window.pageYOffset || document.documentElement.scrollTop,
      left: window.pageXOffset || document.documentElement.scrollLeft
    };
  }
  scrollTop(top = 0) {
    this.scrollTo(0, top);
  }
  scrollTo(options) {
    if (!options) return;
    let isAnimated = options.animated || false;
    let duraction = options.duration || null;
    let x = options.x || null;
    let y = options.y || null;

    window.scrollTo({
      top: y,
      left: x,
      behavior: isAnimated && "smooth"
    });
  }
  scrollToElement(elmt, options = {}) {
    if (!elmt) return false;
    let offset = {
      top: options.top || null,
      left: options.left || null
    };
    if (offset.top === null || offset.left === null) {
      let calcOffset = this.offset(elmt);
      if (offset.top === null) offset.top = calcOffset.top;
      if (offset.left === null) offset.left = calcOffset.left;
    }
    if (options.offsetTop) offset.top -= options.offsetTop;
    this.scrollTo(offset.left, offset.top);
  }
  getBodyWidth() {
    var body = document.body;
    var html = document.documentElement;
    return Math.max(body.scrollWidth, body.offsetWidth, body.getBoundingClientRect().width, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
  getBodyHeight() {
    var body = document.body;
    var html = document.documentElement;
    return Math.max(body.scrollHeight, body.offsetHeight, body.getBoundingClientRect().height, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
  getBodySize() {
    return {
      x: this.getBodyWidth(),
      y: this.getBodyHeight()
    };
  }
  getViewportDimensions() {
    return {
      height: this.getViewportHeight(),
      width: this.getViewportWidth()
    }
  }
  getViewportWidth() {
    if (window.innerWidth) {
      return window.innerWidth;
    }
    else if (document.body && document.body.offsetWidth) {
      return document.body.offsetWidth;
    }
    else {
      return 0;
    }
  }
  getViewportHeight() {
    if (window.innerHeight) {
      return window.innerHeight;
    }
    else if (document.body && document.body.offsetHeight) {
      return document.body.offsetHeight;
    }
    else {
      return 0;
    }
  }
}